import { render } from "./EmailMessageBody.vue?vue&type=template&id=29c5c7c8&scoped=true"
import script from "./EmailMessageBody.vue?vue&type=script&lang=js"
export * from "./EmailMessageBody.vue?vue&type=script&lang=js"

import "./EmailMessageBody.vue?vue&type=style&index=0&id=29c5c7c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c5c7c8"]])

export default __exports__